import React, {Component}                               from "react";
import {ImageBackground, Picker, Platform, Text, View}  from "react-native";
import {connect}                                        from "react-redux";
import Modal                                            from "./Modal";
import NBButton                                         from "../NBButton";
import RNMDropdown                                      from "../RNMDropdown";
import * as Actions                                     from "../../constants/Actions";
import * as Screens                                     from "../../constants/Screens";
import styles                                           from "../../styles/Styles";

class ModalRoundStart extends Component {
    intermission = () => {
        this.props.setAnswer(null);
        this.props.hideCountdown();
        this.props.changeScreen();
    }

    loadActors = (answer) => {
        var movie = this.props.listMovies.find(function(movie) {
            return answer == movie.title;
        });

        this.props.setClues(movie.actors);
        this.props.setCluesExtra(movie.info);
    }

    randomAnswer = () => {
        // Answer is returned because the dispatch is delayed in single player mode
        var index = Math.floor(Math.random() * this.props.listMovies.length);
        var answer = this.props.listMovies[index].title;
        this.props.setAnswer(answer);
        return answer;
    }
    
    selectAnswer = (value) => {
        this.props.setAnswer(value);
    }

    selectAnswerWeb= (itemValue, itemIndex) => {
        this.props.setAnswer(itemValue);
    }

    start = () => {
        //Single Player
        // Select random movie, load actors, and start round.
        if (this.props.numPlayers == 1 || this.props.shareScreen) {
            var answer = this.randomAnswer();
            this.loadActors(answer);
            this.props.start();
        }

        //Multiplayer
        // Verify that next answer has been chosen, then load actors and start round.
        else if (this.props.answer != null) {
            this.loadActors(this.props.answer);
            this.props.start();
        }
    }

    render() {
        //If multiplayer, show answer selection controls
        var controls = null;
        if (this.props.numPlayers > 1 && !this.props.shareScreen) {
            //Dropdown
            var dropdown = null;
            if (Platform.OS === "web") {
                var listMovies = this.props.listMovies.map((movie, index) => {
                    return <Picker.Item key={index} label={movie.title} value={movie.title} />
                });

                dropdown =  <Picker mode="dropdown" onValueChange={this.selectAnswerWeb} prompt="Select Next Movie" selectedValue={this.props.answer} style={styles.dropdownWeb}>
                                {listMovies}
                            </Picker>

                if (this.props.answer == null)
                    this.selectAnswer(this.props.listMovies[0].title);
            }
            else {
                var listMovies = this.props.listMovies.map((movie, index) => ({value: movie.title}));

                dropdown =  <RNMDropdown data={listMovies} label={"Select Next Movie"} onChangeText={(value) => this.selectAnswer(value)}
                    value={this.props.answer != null ? listMovies.find(mov => mov.value == this.props.answer).value : ""} />
            }
            
            controls =  <View>
                            <View style={styles.lineHorizontalModal} />
                            <View style={styles.viewPadded}>
                                {dropdown}
                            </View>
                            <View style={styles.modalButtonPanel}>
                                <NBButton onPress={this.randomAnswer} text={"Select Random"} />
                            </View>
                        </View>;
        }

        return (
            <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.roundStart}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialog}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Header Row */}
                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>Start the Next Round</Text>
                                    </View>

                                    {controls}

                                    <View style={styles.lineHorizontalModal} />

                                    <View style={styles.modalDetailRow}>
                                        <NBButton onPress={this.intermission} text={"Intermission"} />
                                        <NBButton onPress={this.start} text={"Start Round"} />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        answer:         state.answer,
        listMovies:     state.listMovies,
        numPlayers:     state.numPlayers,
        roundStart:     state.roundStart,
        shareScreen:    state.shareScreen
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   ()          => { dispatch({type: Actions.CHANGE_SCREEN,     screen: Screens.CATEGORY}) },
        hideCountdown:  ()          => { dispatch({type: Actions.HIDE_COUNTDOWN}) },
        setAnswer:      (answer)    => { dispatch({type: Actions.SET_ANSWER,        answer: answer}) },
        setClues:       (clues)     => { dispatch({type: Actions.SET_CLUES,         clues:  clues}) },
        setCluesExtra:  (info)      => { dispatch({type: Actions.SET_CLUES_EXTRA,   clues:  info}) },
        start:          ()          => { dispatch({type: Actions.START_ROUND}) },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalRoundStart);